<template>
  <div>
    <span style="margin-right: 10px;">
      {{item.pageStart}}-{{item.pageStop}} of {{item.itemsLength}}
    </span>
    <v-tooltip left>
      <span>Refresh</span>
      <template v-slot:activator="{ on, attrs }">
        <v-icon @click="action" v-bind="attrs" v-on="on">
          mdi-refresh
        </v-icon>
      </template>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: "RefreshTableFooter",
  props: {
    action: Function,
    item: Object,
  },
};
</script>